import { Column } from "@stenajs-webui/core";
import type { MediumIcon } from "@stenajs-webui/elements";
import { Toast } from "@stenajs-webui/modal";
import type { CssPropColor } from "@stenajs-webui/theme";
import type { FC, ReactNode } from "react";

export interface BaseToastProps {
  children?: ReactNode;
  icon: MediumIcon;
  iconBackgroundColor?: CssPropColor;
  onClose: () => void;
  title: string;
}

export const BaseToast: FC<BaseToastProps> = ({
  icon,
  title,
  children,
  onClose,
  iconBackgroundColor,
}) => {
  return (
    <Toast
      icon={icon}
      text={title}
      onClickClose={onClose}
      width={"100%"}
      iconBackgroundColor={iconBackgroundColor}
    >
      <Column width={"100%"}>{children}</Column>
    </Toast>
  );
};
